import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Header } from "../../../components/header";
import { CardHeader } from "../../../components/cards";
import { SendIcon } from "../../../components/icons";
import { Loading } from "../../../components/loading";
import { Input, Select, Textarea } from "../../../components/form";
import { Button } from "../../../components/button";
import { useProspection, useUpdateProspection } from "../hooks";
import { CustomerSelectSearch } from "../../customers/components";
import { ProspectionType } from "../../../__generated__/globalTypes";
import { prospectionTypeLabel } from "../../../helpers/enum-labels";

type IUpdateProspection = {
  id: string;
};

export const UpdateProspection: React.FC = () => {
  const { id } = useParams<IUpdateProspection>();
  const navigate = useNavigate();

  useEffect(() => {
    if (!id) {
      navigate("/");
    }
  }, []);

  const { data, refetch } = useProspection(+id!);
  const { form, submit, loading } = useUpdateProspection({
    id: +id!,
    onCompleted: () => {
      refetch();
      toast.success("La prospection a été modifiée avec succès");
    },
  });

  useEffect(() => {
    if (data?.prospection?.ok && data?.prospection?.result) {
      const { result } = data.prospection;
      form.setValue("customerId", result.customerId);
      form.setValue("type", result.type);
      form.setValue("phone", result.phone);
      form.setValue("email", result.email);
      form.setValue("message", result.message);
    }
  }, [data]);

  if (!data) {
    return <Loading />;
  }

  const prospection = data?.prospection?.result;
  const type = form.watch("type");

  return (
    <>
      <Header
        title="Prospection"
        subtitle={prospection ? `#${prospection.id}` : ""}
        buttons={[
          {
            actionText: "Annuler",
            bgColor: "indigo",
            textColor: "white",
            link: `/prospections`,
            icon: <SendIcon />,
          },
        ]}
      />
      <div className="main-container">
        <div className="card">
          <CardHeader title="Modifier une prospection" />
          <div className="w-full">
            <div className="flex flex-wrap gap-3">
              <CustomerSelectSearch form={form} name="customerId" label="Client (optionnel)" />
              <Select label="Type" className="w-full" {...form.register("type")}>
                {Object.keys(ProspectionType).map((key) => (
                  <option key={key} value={key}>
                    {prospectionTypeLabel(key)}
                  </option>
                ))}
              </Select>
              {type === ProspectionType.Email ? (
                <Input label="Email" type="email" className="w-full" {...form.register("email")} />
              ) : (
                <Input label="Téléphone" className="w-full" {...form.register("phone")} />
              )}
              <Textarea label="Message" className="w-full" {...form.register("message")} />
            </div>
            <div className="w-full mt-4">
              <Button onClick={submit} loading={loading} disabled={loading}>
                Valider
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
